<template>

    <div>
        <section class="contact-new">
            <div v-if="showPageLoader" class="loader">
                <div><i class="fas fa-circle-notch fa-spin"></i></div>
            </div>
            <div class="ink-grid">
                <div class="nav small half-vertical-padding">
                    <a href="#" onclick="history.back()"><i class="fas fa-chevron-left"></i> Voltar a detalhe</a>
                </div>
                <div class="has-sidebar clearfix">

                    <div class="content card">

                        <fieldset>
                            <legend>Contactar vendedor</legend>
                        </fieldset>

                        <fieldset>
                            <div class="control-group half-gutters">
                                <div class="control-group required all-70 small-100 tiny-100" v-bind:class="{ 'validation-error': showContactOptionMessageError}">
                                    <label for="ContactOptions">Mensagem</label>
                                    <div class="control">
                                        <select id="ContactOptions" class="selectpicker squared show-tick" title="Escolha..."
                                            data-style="ink-button" data-width="100%" v-model="selectedOption"  @change="onOptionsChanged">
                                            <option v-for="item in this.contactOptions"
                                                v-bind:key="item.Key" v-bind:value="item.Key">
                                                {{ item.Value }}</option>
                                        </select>
                                    </div>
                                    <p class="error">{{ contactOptionMessageError }}</p>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset v-if="selectedOption == 99">
                            <div class="column-group half-gutters">
                                <div class="control-group required all-100" v-bind:class="{ 'validation-error': showContactMessageError}">
                                    <label for="message">Mensagem</label>
                                    <div class="control half-bottom-space">
                                        <textarea id="message" v-model="contactMessage"></textarea>
                                    </div>
                                    <p class="error">{{ contactMessageError }}</p>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <div class="column-group gutters">

                                <div class="control-group all-50 small-100 tiny-100">
                                    <div class="control check-group">
                                        <input id="retomaInput" type="checkbox" v-model="hasRetoma">
                                        <label class="section-collapse collapsed" for="retomaInput" data-toggle="collapse" href="#retoma" role="button" aria-expanded="false" ><span>Tem retoma?</span></label>
                                    </div>

                                    <div class="collapse box framed" id="retoma">
                                        <div class="control-group" v-bind:class="{ 'validation-error': showRetomaPlateMessageError}">
                                            <label for="PlateStart">Matrícula</label>
                                            <div class="control plate">
                                                <input class="plate-input" id="PlateStart" maxlength="2" minlength="2" name="PlateStart" size="2" title="Introduza dois caracteres entre A-Z ou 0-9." type="text" v-model="retomaMessage.plateStart">
                                                <input class="plate-input" id="PlateMid" maxlength="2" minlength="2" name="PlateMid" size="2" title="Introduza dois caracteres entre A-Z ou 0-9." type="text" v-model="retomaMessage.plateMid">
                                                <input class="plate-input" id="PlateEnd" maxlength="2" minlength="2" name="PlateEnd" size="2" title="Introduza dois caracteres entre A-Z ou 0-9." type="text" v-model="retomaMessage.plateEnd">
                                            </div>
                                            <p class="error">{{retomaPlateMessageError}}</p>
                                        </div>

                                        <div class="control-group" v-bind:class="{ 'validation-error': showRetomaKilometerMessageError}">
                                            <label for="Kms">Quilómetros</label>
                                            <div class="control all-100">
                                                <input id="Kms" name="Kms" type="text" v-model.lazy="retomaMessage.kilometer">
                                            </div>
                                            <p class="error">{{retomaKilometerMessageError}}</p>
                                        </div>

                                    </div>
                                </div>

                                <div class="control-group all-50 small-100 tiny-100">
                                    <div class="control check-group">
                                        <input id="financiamentoInput" type="checkbox" v-model="hasFinancing">
                                        <label class="section-collapse collapsed" for="financiamentoInput" data-toggle="collapse" href="#financiamento" role="button" aria-expanded="false"><span>Pretende financiamento?</span></label>
                                    </div>

                                    <div class="collapse box framed" id="financiamento">
                                        <div class="control-group" v-bind:class="{ 'validation-error': showFinancingIncomingMessageError}">
                                            <label for="EntryValue">Valor de entrada</label>
                                            <div class="control all-100 euro">
                                                <input id="EntryValue" name="EntryValue"  type="text" v-model.lazy="financiamentoMessage.incoming">
                                            </div>
                                            <p class="error">{{financingIncomingMessageError}}</p>
                                        </div>

                                        <div class="control-group" v-bind:class="{ 'validation-error': showFinancingMontlyPaymMessageError}">
                                            <label for="MonthlyPayment">Mensalidade</label>
                                            <div class="control all-100 euro">
                                                <input id="MonthlyPayment" name="MonthlyPayment" type="text" v-model.lazy="financiamentoMessage.montlyPayment">
                                            </div>
                                            <p class="error">{{financingMontlyPaymMessageError}}</p>
                                        </div>

                                    </div>
                                </div>
                            </div>                                
                            <div class="control-group">
                                <div class="control-group all-70 small-100 tiny-100 required"  v-bind:class="{ 'validation-error': showLocationsOptionMessageError}">
                                    <label for="Locations">Ponto de venda preferencial</label>
                                    <div class="control">
                                        <select id="Locations" class="selectpicker squared show-tick" title="Escolha..." data-size="5" multiple data-max-options="1"
                                            data-style="ink-button" data-width="100%" v-model="selectedLocations">
                                            <option v-for="item in this.propAdvLocations"
                                                v-bind:key="item.IdPublic" v-bind:value="item" v-bind:data-subtext="item.Address + `, ` + item.District + `, ` + item.County">
                                                {{ item.Name }} </option>
                                        </select>
                                    </div>
                                    <p class="error">{{ locationsOptionMessageError }}</p>
                                </div>
                            </div>
                        </fieldset>

                        <div class="all-100 half-vertical-space">
                            <div class="push-right">
                                <button class="ink-button main-action min-width" :disabled="showPageLoader" v-on:click="Send" type="button">Enviar</button>
                            </div>
                            <small><i class="fas fa-asterisk"></i> Campos obrigatórios</small>

                        </div>
                    </div>
                    <aside>
                        <vehicleResume contactPage="true" :ad-details=this.propAdData></vehicleResume>
                    </aside>

                </div>
            </div>

        </section>

        <section class="suggested top-space">

        <!--     <div class="ink-grid">
                <div class="content">
                    <h2 class="section-title">Veja também</h2>

                    <div class="column-group gutters">
                        <div class="tiny-100 small-100 medium-50 large-25 xlarge-25" v-for="n in 4">
                            <VehicleCard newVehicle></VehicleCard>
                        </div>
                    </div>

                </div>

            </div> -->


        </section> 
    </div>

</template>

<script>

    import vehicleResume from './new-vehicle-resume.vue'
    // import VehicleCard from '../shared/vehicle-card.vue'
    import leadsClient from '../scripts/services/leadsClient';
    import * as Constants from '../scripts/constants.js';
    import notifications from "../scripts/notifications"

    Vue.config.devtools = true;

    export default {
        data () {
            return {
                showPageLoader: false,
                contactMessage: '',
                selectedOption: 1,
                contactOptions: [
                    { Key:1, Value: "Pretendo saber mais informações sobre esta viatura." },
                    { Key:2, Value: "Pretendo agendar um test-drive a esta viatura." },
                    { Key:3, Value: "Pretendo agendar uma visita ao Ponto de Venda." },
                    { Key:99, Value: "Personalizar mensagem" }
                ],
                hasRetoma: false,
                retomaMessage:{
                    plateStart:'',
                    plateMid:'',
                    plateEnd:'',
                    kilometer:'',
                    toString(){
                        return "Retoma: \nMatricula: " + this.plateStart + "-" + this.plateMid + "-" + this.plateStart + "\nQuilómetros: " + this.kilometer
                    }
                },
                hasFinancing: false,
                financiamentoMessage:{
                    incoming: '',
                    montlyPayment: '',
                    toString(){
                        return "Proposta de Financiamento: \nEntrada: " + this.incoming + "€ \nMensalidade: " + this.montlyPayment + "€" 
                    }
                },
                selectedLocations: [],
                contactMessageError: "",
                retomaPlateMessageError: "",
                retomaKilometerMessageError: "",
                financingIncomingMessageError: "",
                financingMontlyPaymMessageError: "",
                contactOptionMessageError: "",
                locationsOptionMessageError: "",
                showContactMessageError: false,
                showRetomaPlateMessageError: false,
                showRetomaKilometerMessageError: false,
                showFinancingIncomingMessageError: false,
                showFinancingMontlyPaymMessageError: false,
                showContactOptionMessageError: false,
                showLocationsOptionMessageError: false,
            }
        },        
        components: {
            vehicleResume,
            // VehicleCard
        },
        props: {
            propIdPub: String,
            propAdData: Object,
            propAdvLocations: Array
        },
        mounted () {
            this.propAdData = JSON.parse(this.propAdData);
            this.propAdvLocations = JSON.parse(this.propAdvLocations);

            console.log(this.propAdvLocations, "this.propAdvLocations");

            this.onOptionsChanged();

            let selectedOption = this.selectedOption;
                       
            $(".plate-input").keyup(function () {
                if (this.value.length == this.maxLength) {
                    $(this).next('.plate-input').focus();
                }
            });
            
            $("#Kms").mask("#.##0", { reverse: true });
            $("#EntryValue").mask("#.##0", { reverse: true });
            $("#MonthlyPayment").mask("#.##0", { reverse: true });
            
            $("#ContactOptions").val(selectedOption);
            $("#ContactOptions").selectpicker('refresh');
           
        },
        methods:{
            async onOptionsChanged(){
                if (this.selectedOption == 0
                    || this.selectedOption == 99){
                    this.contactMessage = "";
                }else{
                    this.contactMessage = this.contactOptions.filter(i => i.Key == this.selectedOption)[0].Value;
                }
                
                this.contactOptionMessageError = "";
                this.showContactOptionMessageError = false;

                this.contactMessageError = "";
                this.showContactMessageError = false;
            },
            getMessages(){
                let message = this.contactMessage;

                if (this.hasRetoma){
                    //check if its ok
                    message = message + "\n\n" + this.retomaMessage.toString();
                }

                if (this.hasFinancing){
                    //check if its ok
                    message = message + "\n\n" + this.financiamentoMessage.toString();
                }

                if (this.selectedLocations != null && this.selectedLocations != [] && this.selectedLocations.length > 0){
                    if(this.selectedLocations.length > 1){
                        message = message + "\n\nPontos de venda preferenciais: "
                    }else{
                        message = message + "\n\nPonto de venda preferencial: "
                    }

                    for (let i = 0; i < this.selectedLocations.length; i++) {
                        const item = this.selectedLocations[i];

                        if (this.selectedLocations.length > 1){
                            message = message + '\n';
                        }

                        message = message + item.Name + " (" + item.Address + ", " + item.District + ", " + item.County + ")";
                    }
                }
                
                let messages = [{
                                    Body: message
                                }];

                return messages;
            },
            IsContactMessageValid(){
                let valid = this.contactMessage != null && this.contactMessage.trim() != ""; 
                if (!valid){
                    this.contactMessageError = "Campo obrigatório";
                    this.showContactMessageError = true;
                }else{
                    this.contactMessageError = "";
                    this.showContactMessageError = false;
                }
                return valid;
            },
            IsRetomaMessageValid(){
                let valid =  true;
                if (this.hasRetoma){
                    if (this.retomaMessage.plateStart == "" ||
                        this.retomaMessage.plateMid == "" ||
                        this.retomaMessage.plateEnd == ""){
                        this.retomaPlateMessageError = "Campo obrigatório";
                        valid = false;
                        this.showRetomaPlateMessageError = true;
                    }else{ this.retomaPlateMessageError = ""; this.showRetomaPlateMessageError = false; }

                    if (this.retomaMessage.kilometer == ""){
                        this.retomaKilometerMessageError = "Campo obrigatório";
                        valid = false;
                        this.showRetomaKilometerMessageError = true;
                    }else{ this.retomaKilometerMessageError = ""; this.showRetomaKilometerMessageError = false;}
                }
                return valid;
            }, 
            IsFinancingMessageValid(){
                let valid =  true;
                if (this.hasFinancing){
                    if (this.financiamentoMessage.incoming == ""){
                        this.financingIncomingMessageError = "Campo obrigatório";
                        valid = false;
                        this.showFinancingIncomingMessageError = true;
                    }else{ this.financingIncomingMessageError = ""; this.showFinancingIncomingMessageError = false; }

                    if (this.financiamentoMessage.montlyPayment == ""){
                        this.financingMontlyPaymMessageError = "Campo obrigatório";
                        valid = false;
                        this.showFinancingMontlyPaymMessageError = true;
                    }else{ this.financingMontlyPaymMessageError = ""; this.showFinancingMontlyPaymMessageError = false; }
                }
                return valid;
            }, 
            IsSelectedOptionValid(){
                let valid = this.selectedOption != 0; 
                if (!valid){
                    this.contactOptionMessageError = "Campo obrigatório";
                    this.showContactOptionMessageError = true;
                }else{
                    this.contactOptionMessageError = "";
                    this.showContactOptionMessageError = false;
                }
                return valid;
            },
            IsSelectedLocationValid(){
                let valid = this.selectedLocations != null && this.selectedLocations.length > 0; 
                if (!valid){
                    this.locationsOptionMessageError = "Campo obrigatório";
                    this.showLocationsOptionMessageError = true;
                }else{
                    this.locationsOptionMessageError = "";
                    this.showLocationsOptionMessageError = false;
                }
                return valid;
            },
            IsFormValid(){
                return this.IsSelectedOptionValid() & this.IsContactMessageValid() & this.IsRetomaMessageValid() & this.IsFinancingMessageValid() & this.IsSelectedLocationValid();
            },
            Send: async function(){
                if (this.IsFormValid()){
                    this.showPageLoader = true;
                    var formToSend = {
                        IdAdPub: this.propIdPub,
                        IdPublicProcurementRequest: this.propAdData.ProcurementInfo != null ? this.propAdData.ProcurementInfo.IdPublicProcurementRequest : null,
                        Price: this.propAdData != null && this.propAdData.ProcurementInfo != null && this.propAdData.ProcurementInfo.NewPrice != null ? 
                                    this.propAdData.ProcurementInfo.NewPrice : this.propAdData.Advert.Price.Total,
                        Messages: this.getMessages()
                    };

                    let result = await leadsClient.CreateLeadFromAd(formToSend);
                    if (result){
                        if (result.Success){
                            window.location = "/user/messages/?confirmcontact=true";
                        }else{
                            if (result.Errors != null && result.Errors.length > 0){
                                let error = result.Errors.filter(i => {return i.Nature == 'v'});
                                if (error != null && result.Errors.length > 0){
                                    notifications.Error('Contactar', error[0].Message);
                                }
                            }
                            else
                            {
                                notifications.Error('Contactar', "Ocorreu um erro inesperado. Tente novamente.");
                            }
                        }
                    }
                    this.showPageLoader = false;
                }
            }
        },        
        watch:{
            'contactMessage'(newValue, oldValue){
                if (this.showContactMessageError){
                    if (newValue != undefined && newValue != "" && newValue != oldValue){
                        this.showContactMessageError = false;
                        this.contactMessageError = "";
                    }
                }
            },
            'retomaMessage.plateStart'(newValue, oldValue){
                if (this.showRetomaPlateMessageError){
                    if (newValue != undefined && newValue != "" && newValue != oldValue){
                        this.showRetomaPlateMessageError = false;
                        this.retomaPlateMessageError = "";
                    }
                }
            },
            'retomaMessage.plateMid'(newValue, oldValue){
                if (this.showRetomaPlateMessageError){
                    if (newValue != undefined && newValue != "" && newValue != oldValue){
                        this.showRetomaPlateMessageError = false;
                        this.retomaPlateMessageError = "";
                    }
                }
            },
            'retomaMessage.plateEnd'(newValue, oldValue){
                if (this.showRetomaPlateMessageError){
                    if (newValue != undefined && newValue != "" && newValue != oldValue){
                        this.showRetomaPlateMessageError = false;
                        this.retomaPlateMessageError = "";
                    }
                }
            },
            'retomaMessage.kilometer'(newValue, oldValue){
                if (this.showRetomaKilometerMessageError){
                    if (newValue != undefined && newValue != "" && newValue != oldValue){
                        this.showRetomaKilometerMessageError = false;
                        this.retomaKilometerMessageError = "";
                    }
                }
            },
            'financiamentoMessage.incoming'(newValue, oldValue){
                if (this.showFinancingIncomingMessageError){
                    if (newValue != undefined && newValue != "" && newValue != oldValue){
                        this.showFinancingIncomingMessageError = false;
                        this.financingIncomingMessageError = "";
                    }
                }
            },
            'financiamentoMessage.montlyPayment'(newValue, oldValue){
                if (this.showFinancingMontlyPaymMessageError){
                    if (newValue != undefined && newValue != "" && newValue != oldValue){
                        this.showFinancingMontlyPaymMessageError = false;
                        this.financingMontlyPaymMessageError = "";
                    }
                }
            },
            'selectedLocations'(newValue, oldValue){
                if (this.showLocationsOptionMessageError){
                    if (newValue != undefined && newValue != "" && newValue != oldValue){
                        this.showLocationsOptionMessageError = false;
                        this.locationsOptionMessageError = "";
                    }
                }
            },
        },
    };

</script>